(ns journal-app-client.components.tree
  (:require [journal-app-client.components.button :as button]
            [journal-app-client.utils.formatting :as fmt]
            [journal-app-client.utils.interop :as interop]
            [journal-app-client.utils.react :as react]
            [clojure.string :as s]
            [re-frame.core :as rf]))

(defn context-menu [& [props]]
  (let [[state set-state] (:use-state props)
        context-menu-props (:context-menu-props state)
        bounding-rect (:bounding-client-rect context-menu-props)
        container-rect (:container-bounding-client-rect context-menu-props)]
    (when (and bounding-rect container-rect)
      (let [container-scroll (:container-scroll context-menu-props)
            margin 10
            container-x (+ margin (.-x container-rect))
            container-y (+ margin (.-y container-rect))
            container-right (+ (.-right container-rect) (:x container-scroll) margin)
            container-bottom (+ (.-bottom container-rect) (:y container-scroll) margin)
            x (Math/max (- (+ (.-x bounding-rect) (:x container-scroll)) (- container-x margin)) container-x)
            y (Math/max (- (+ (.-y bounding-rect) (:y container-scroll)) (- container-y margin)) container-y)
            menu-width "12rem"
            id (:id context-menu-props)
            children (:children context-menu-props)]
        (when context-menu-props
          [:div.box
           {:class            (if (get-in state [:context-menu-props :animate-out?])
                                "fade-out-bottom"
                                "fade-in-bottom")
            :style            {:position           "absolute"
                               :top                (str "min(calc(" y "px + 2.25rem), " container-bottom "px)")
                               :left               (str "min(calc(" x "px - " menu-width " / 2), " container-right "px)")
                               :z-index            "3"
                               "--scheme-main"     "hsla(var(--scheme-main-hsl), 1)"
                               :margin             "0"
                               :padding            "0.75rem"
                               :width              menu-width
                               :animation-duration "var(--transition-duration)"
                               :transition         "top var(--transition-duration) ease, left var(--transition-duration) ease"}
            :on-animation-end (fn [event]
                                (when (= (.-animationName event) "fade-out-bottom")
                                  (set-state (dissoc state :context-menu-props))))}
           [button/button
            {:class    " is-small is-outlined is-success is-fullwidth"
             :style    {:margin-bottom   "0.75rem"
                        :justify-content "space-between"}
             :on-click (fn [event]
                         (.stopPropagation event)
                         (set-state (assoc state (:type props) nil
                                           :children children
                                           :parent-id id
                                           :context-menu-props nil))
                         (rf/dispatch [:select-view (:view props) {:sub-view :create}]))}
            [:span (str "Create " (name (:type props)))]
            [:span.icon.is-left [:i.fas.fa-plus]]]
           [button/button
            {:class    " is-small is-outlined is-success is-fullwidth"
             :style    {:margin          "0"
                        :justify-content "space-between"}
             :on-click (fn [event]
                         (.stopPropagation event)
                         (set-state (dissoc state :context-menu-props))
                         (rf/dispatch [:select-view :venues {:sub-view :create
                                                             :context-menu-props
                                                             {:parent {:id id :type (:type props)}}}]))}
            [:span "Create venue"]
            [:span.icon.is-left [:i.fas.fa-plus]]]])))))

(defn create-button [& {:keys [loading use-state parent children] :as props}]
  (let [[state set-state] use-state
        disabled-due-to-search? (:disabled-due-to-search? props)
        selected-node? (:selected-node? props)
        id (first parent)
        window-size @(rf/subscribe [:window-size])
        ref (react/use-ref nil)]
    (react/use-effect
      (fn []
        (when (= id (get-in state [:context-menu-props :id]))
          (let [container (interop/get-element-by-id "tree-view-container")]
            (set-state (assoc state
                              :context-menu-props {:container-bounding-client-rect (.getBoundingClientRect container)
                                                   :container-scroll     {:x (.-scrollLeft container)
                                                                          :y (.-scrollTop container)}
                                                   :bounding-client-rect (.getBoundingClientRect (.-current ref))
                                                   :id                   id
                                                   :children             children
                                                   :animate-out?         false}))))
        (fn []))
      #js [window-size])
    [button/button
     {:ref ref
      :class    "is-rounded is-small is-info is-outlined "
      :style    {:position       "absolute"
                 :top            "2.25rem"
                 :left           "calc(50% - (2.5em) / 2)"
                 :z-index        "1"
                 "--scheme-main" "hsla(var(--scheme-main-hsl), 1)"
                 :margin         "0"
                 :opacity        (if (or disabled-due-to-search? (not selected-node?)) "0.5" "1")
                 :width          "2.5em"}
      :loading? (:patch! loading)
      :disabled (or disabled-due-to-search? (not selected-node?))
      :on-click (fn [event]
                  (.stopPropagation event)
                  (let [container (interop/get-element-by-id "tree-view-container")]
                    (set-state (assoc state
                                      :context-menu-props {:container-bounding-client-rect (.getBoundingClientRect container)
                                                           :container-scroll     {:x (.-scrollLeft container)
                                                                                  :y (.-scrollTop container)}
                                                           :bounding-client-rect (.getBoundingClientRect (.-target event))
                                                           :id                   id
                                                           :children             children
                                                           :animate-out?         false}))))}
     [:span.icon.is-left [:i.fas.fa-plus]]]))

(defn delete-button [& [{:keys [show-delete-button? loading disabled-due-to-search?
                                selected-node? super-node? parent info-name use-state] :as props}]]
  (let [[state set-state] use-state
        value (second parent)]
    (when show-delete-button?
      (if (:confirm-patch-delete-fn props)
        [button/button
         {:class    (str (:class props) " is-danger is-outlined ")
          :style    {:margin                    "0"
                     :width                     "2.5rem"
                     :border-bottom-left-radius 0
                     :border-top-left-radius    0
                     :opacity                   (if (or disabled-due-to-search? (not selected-node?)) "0.5" "1")}
          :loading? (:patch! loading)
          :disabled (or super-node? disabled-due-to-search? (not selected-node?))
          :on-click (fn [event]
                      (.stopPropagation event)
                      (rf/dispatch
                        [:open-modal :confirm
                         {:title    (str "Delete " (name (:type props)) "?")
                          :confirm-props
                          {:class    "is-danger"
                           :loading? (:patch! loading)
                           :on-click
                           (fn []
                             (set-state (dissoc state :context-menu-props))
                             (rf/dispatch [:dispatch-many
                                           [(when (fn? (:confirm-patch-delete-fn props))
                                              [:dispatch ((:confirm-patch-delete-fn props) parent)])
                                            [:dispatch [:close-modal :confirm]]]]))}
                          :children [:div.box
                                     {:style {:display         "flex"
                                              :flex-direction  "column"
                                              :justify-content "center"
                                              :align-items     "center"}}
                                     [:span.icon.is-large
                                      {:style {:color "var(--danger)"}}
                                      [:i.fas.fa-times-circle.fa-3x]]
                                     [:p.subtitle
                                      [:span "Please confirm that you want to delete "]
                                      [:span
                                       {:style {:text-decoration "underline"
                                                :color           "var(--danger)"}}
                                       info-name]
                                      [:span (str " " (name (:type props)))]]]}]))}
         [:span.icon.is-left
          [:i.fas.fa-times]]]
        (if (:archived-ts value)
          [button/button
           {:class    (str (:class props) " is-info is-outlined ")
            :style    {:margin                    "0"
                       :width                     "2.5rem"
                       :border-bottom-left-radius 0
                       :border-top-left-radius    0
                       :opacity                   (if (or disabled-due-to-search? (not selected-node?)) "0.5" "1")}
            :loading? (:patch! loading)
            :disabled (or super-node? disabled-due-to-search? (not selected-node?))
            :on-click (fn [event]
                        (.stopPropagation event)
                        (rf/dispatch
                          [:open-modal :confirm
                           {:title    (str "Unarchive " (name (:type props)) "?")
                            :confirm-props
                            {:class    "is-info"
                             :loading? (:patch! loading)
                             :on-click
                             (fn []
                               (set-state (dissoc state :context-menu-props))
                               (rf/dispatch [:dispatch-many
                                             [(when (fn? (:confirm-patch-unarchive-fn props))
                                                [:dispatch ((:confirm-patch-unarchive-fn props) parent)])
                                              [:dispatch [:close-modal :confirm]]]]))}
                            :children [:div.box
                                       {:style {:display         "flex"
                                                :flex-direction  "column"
                                                :justify-content "center"
                                                :align-items     "center"}}
                                       [:span.icon.is-large
                                        {:style {:color "var(--info)"}}
                                        [:i.fas.fa-folder-open.fa-3x]]
                                       [:p.subtitle
                                        [:span "Please confirm that you want to unarchive "]
                                        [:span
                                         {:style {:text-decoration "underline"
                                                  :color           "var(--info)"}}
                                         info-name]
                                        [:span (str " " (name (:type props)))]]]}]))}
           [:span.icon.is-left
            [:i.fas.fa-folder-open]]]
          [button/button
           {:class    (str (:class props) " is-warning is-outlined ")
            :style    {:margin                    "0"
                       :width                     "2.5rem"
                       :border-bottom-left-radius 0
                       :border-top-left-radius    0
                       :opacity                   (if (or disabled-due-to-search? (not selected-node?)) "0.5" "1")}
            :loading? (:patch! loading)
            :disabled (or super-node? disabled-due-to-search? (not selected-node?))
            :on-click (fn [event]
                        (.stopPropagation event)
                        (rf/dispatch
                          [:open-modal :confirm
                           {:title    (str "Archive " (name (:type props)) "?")
                            :confirm-props
                            {:class    "is-warning"
                             :loading? (:patch! loading)
                             :on-click
                             (fn []
                               (set-state (dissoc state :context-menu-props))
                               (rf/dispatch [:dispatch-many
                                             [(when (fn? (:confirm-patch-archive-fn props))
                                                [:dispatch ((:confirm-patch-archive-fn props) parent)])
                                              [:dispatch [:close-modal :confirm]]]]))}
                            :children [:div.box
                                       {:style {:display         "flex"
                                                :flex-direction  "column"
                                                :justify-content "center"
                                                :align-items     "center"}}
                                       [:span.icon.is-large
                                        {:style {:color "var(--warning)"}}
                                        [:i.fas.fa-folder.fa-3x]]
                                       [:p.subtitle
                                        [:span "Please confirm that you want to archive "]
                                        [:span
                                         {:style {:text-decoration "underline"
                                                  :color           "var(--warning)"}}
                                         info-name]
                                        [:span (str " " (name (:type props)))]]]}]))}
           [:span.icon.is-left
            [:i.fas.fa-folder]]])))))

(defn expand-button [& [{:keys [children disabled-due-to-search? selected? selected-node? open? parent use-state
                                active-search? included-in-search?] :as props}]]
  (let [[state set-state] use-state]
    (when children
      [button/button
       {:class    (str (:class props)
                       (cond selected?
                             " is-success "
                             (and active-search? included-in-search?)
                             " is-info "
                             :else " is-outlined "))
        :style    (merge {:margin                    "0"
                          :width                     "2.5rem"
                          :justify-content           "space-between"
                          :border-bottom-left-radius 0
                          :border-top-left-radius    0
                          :opacity                   (if (or disabled-due-to-search? (not selected-node?)) "0.5" "1")}
                         (:style props))
        :on-click (fn [event]
                    (.stopPropagation event)
                    (set-state (if (true? (:open state))
                                 (assoc-in (dissoc state :open) [:open (first parent)] (not open?))
                                 (assoc-in state [:open (first parent)] (not open?)))))}
       [:span.icon.is-small.is-left
        {:style {:transform  (if open? "rotate(0deg)" "rotate(180deg)")
                 :transition "transform var(--transition-duration) ease"}}
        [:i.fas.fa-caret-down]]])))

(defn tree-button [{:keys [use-state parent children on-click badge-props-fn disabled] :as props}]
  (let [[state set-state] use-state
        id (first parent)
        value (second parent)
        info-name (:info-name props)
        short-name (:short-name props)
        search (:search props)
        active-search? (and search (not (= search "")))
        super-node? (= (:super-parent-id props) id)
        included-in-search? (:included-in-search? props)
        disabled? (if (fn? disabled)
                    (disabled {:parent parent :children children})
                    disabled)
        selected? (contains? (:selected-ids state) id)
        selected-node? (or (empty? (:selected-ids state)) selected?)
        disabled-due-to-search? (and (:disabled-due-to-search? props) active-search? (not included-in-search?))
        show-delete-button? (if (fn? (:show-delete-button-fn props))
                              ((:show-delete-button-fn props) parent)
                              (and (not children) (not super-node?)))
        hide-create-button? (:hide-create-button? props)
        badge-props (when (fn? badge-props-fn) (badge-props-fn {:parent parent}))]
    [:a.fade-in
     {:title    info-name
      :class    (str (when (and (not disabled?) (or (and active-search? included-in-search?) selected?)) " is-hovered ")
                     (when badge-props
                       (str (when (s/includes? (or (:class props) "") "is-small") " badge-is-small ")
                            " badge is-centered-horizontally ")))
      :style    (merge {:max-width (or (:max-width (:style props)) "12rem")
                        :padding   "0"
                        :z-index   "1"}
                       badge-props)}
     (when-not hide-create-button?
       [:f> create-button
        (assoc (dissoc props :style) :selected-node? selected-node? :disabled-due-to-search? disabled-due-to-search?)])
     [button/button
      {:class    (str (cond selected?
                            " is-success "
                            (and active-search? included-in-search?)
                            " is-info "
                            :else " is-outlined ")
                      (:class props))
       :style    {:margin                     "0"
                  :width                      (or (:width (:style props)) "12rem")
                  :max-width                  (cond (and children show-delete-button?)
                                                    "calc(100% - 5rem)"
                                                    (or children show-delete-button?)
                                                    "calc(100% - 2.5rem)"
                                                    :else
                                                    "100%")
                  :min-width                  "5rem"
                  "--scheme-main"             "hsla(var(--scheme-main-hsl), 1)"
                  :justify-content            "space-between"
                  :opacity                    (if (or disabled-due-to-search? (not selected-node?) disabled?)
                                                "0.5" "1")
                  :border-bottom-right-radius (when (or children show-delete-button?) 0)
                  :border-top-right-radius    (when (or children show-delete-button?) 0)}
       :disabled (or super-node? disabled-due-to-search? (not selected-node?) disabled?)
       :on-click (fn [event]
                   (.stopPropagation event)
                   (if (fn? on-click)
                     (on-click {:parent parent :children children})
                     (do (set-state (assoc state (:type props) [id (dissoc value :children)]
                                           :parent-id nil
                                           :children children))
                         (rf/dispatch [:select-view (:view props) {:sub-view  (or (:sub-view props) :choices)
                                                                   :query-map {(:type props) id}}]))))}
      [:span.text-overflow (str (when (:archived-ts value) "Archived - ") (or info-name short-name id))]
      (when-not (or super-node? disabled-due-to-search? (not selected-node?) disabled?)
        [:span.icon.is-left [:i.fas.fa-edit]])]
     [delete-button
      (assoc (dissoc props :style)
             :show-delete-button? show-delete-button?
             :disabled-due-to-search? disabled-due-to-search?
             :selected-node? selected-node?
             :super-node? super-node?)]
     [expand-button
      (assoc (dissoc props :style)
             :disabled-due-to-search? disabled-due-to-search?
             :selected-node? selected-node?
             :super-node? super-node?
             :active-search? active-search?
             :included-in-search? included-in-search?)]]))

(defn tree-structure [{:keys [initialized? children get-name-fn info-name short-name included-in-search?] :as props}]
  (let [[state _] (:use-state props)
        column-children? (when initialized?
                           (reduce
                             (fn [r v]
                               (and r (or (not (:children (second v))) (not (get-in state [:open (first v)])))))
                             true children))
        group-children? (when (and (:group-children? props) initialized?)
                          (reduce
                            (fn [r v]
                              (and r (not (:children (second v)))))
                            true children))
        search (or (:search props) (fmt/lower-case @(rf/subscribe [:main-search-input])))
        parent-included-in-search? (or included-in-search? (s/includes? (fmt/lower-case (str short-name info-name)) search))
        content (into
                  [:ul (cond group-children?
                             {:style {:display          "flex"
                                      :flex-direction   "column"
                                      "--node-distance" (when (:hide-create-button? props) "0.5rem")}}
                             column-children?
                             {:style {:display          "flex"
                                      :flex-direction   "column"
                                      "--node-distance" (when (:hide-create-button? props) "1.5rem")}})]
                  (map-indexed
                    (fn [index parent]
                      (let [id (first parent)
                            value (second parent)
                            children (:children value)
                            info-name (if (fn? get-name-fn)
                                        (get-name-fn value)
                                        (get-in value [:information :name] "Unnamed"))
                            short-name (get-in value [:information :short-name])
                            included-in-search? (s/includes? (fmt/lower-case (str short-name info-name)) search)
                            open? (get-in state [:open id])
                            new-props (assoc props :initialized? true
                                             :parent parent
                                             :children children
                                             :search search
                                             :info-name info-name
                                             :short-name short-name
                                             :open? open?
                                             :included-in-search? (if parent-included-in-search? true included-in-search?))]
                        [:li
                         {:key   (str "tree-" id)
                          :style (merge {"--hover-border-color" (when (and (not (empty? (:selected-ids state)))
                                                                           (contains? (:selected-ids state) id))
                                                                  "var(--success)")}
                                        (when column-children?
                                          {:padding-top         (when (= index 0) "0")
                                           "--border-radius"    "0"
                                           "--border-top-width" "0"}))}
                         [tree-button (merge new-props
                                             (cond group-children?
                                                   {:class "is-small"
                                                    :style {:max-width "10rem"
                                                            :width     "10rem"}}
                                                   column-children?
                                                   {:style {:max-width "10rem"
                                                            :width     "10rem"}}))]
                         (when (and children open?)
                           [tree-structure new-props])]))
                    (when children (sort-by #(if (fn? get-name-fn)
                                               (get-name-fn (second %))
                                               (get-in (second %) [:information :name]
                                                       (get-in (second %) [:information :short-name])))
                                            children))))]
    (if initialized?
      content
      [:div.tree
       {:style {"--node-distance"          "3em"
                "--hover-background-color" "transparent"}}
       content])))

(defn tree-indented-button [{:keys [icon use-state children parent on-click name short-name hovered? selected? disabled badge-props-fn] :as props}]
  (let [[state set-state] use-state
        disabled? (if (fn? disabled)
                    (disabled {:parent parent :children children})
                    disabled)
        badge-props (when (fn? badge-props-fn) (badge-props-fn {:parent parent}))]
    [:a.fade-in
     {:title    name
      :class    (str (when (and (not disabled?) hovered?) " is-hovered ")
                     (when badge-props " badge-is-medium badge is-left is-centered-vertically "))
      :style    (merge {:width                 "100%"
                        :padding               "0"
                        :display               "flex"
                        "--border-radius"      "var(--border-radius-small)"
                        "--hover-border-color" (when disabled? "var(--border)")}
                       badge-props)}
     [button/button
      {:class    (str " is-fullwidth is-small "
                      (if selected?
                        " is-success"
                        " is-outlined "))
       :style    {:margin                     "0"
                  :width                      (when children "calc(100% - 2.5em)")
                  :justify-content            "space-between"
                  :border-bottom-right-radius (when children 0)
                  :border-top-right-radius    (when children 0)}
       :disabled disabled?
       :on-click (fn [event]
                   (.stopPropagation event)
                   (set-state (assoc state :selected-ids
                                     (if selected?
                                       (disj (:selected-ids state) (first parent))
                                       (conj (:selected-ids state) (first parent)))))
                   (when (fn? on-click)
                     (on-click {:parent parent :children children})))}
      [:span.text-overflow
       [:span (str (when (:archived-ts (second parent)) "Archived - ") (or name short-name))]]
      (when (and (not disabled?) icon)
        [:span.icon.is-left [icon]])]
     [expand-button (assoc props
                           :class " is-small "
                           :style {:width   "2.5em"
                                   :opacity "1"})]]))

(defn tree-indented [{:keys [initialized? children get-name-fn] :as props}]
  (let [[state _] (:use-state props)
        [auto-animate-ref] (react/use-auto-animate)
        content (into
                  [:ul]
                  (map
                    (fn [parent]
                      (let [id (first parent)
                            value (second parent)
                            children (:children value)
                            name (if (fn? get-name-fn)
                                   (get-name-fn value)
                                   (get-in value [:information :name] "Unnamed"))
                            short-name (get-in value [:information :short-name])
                            search (or (:search props) (fmt/lower-case @(rf/subscribe [:main-search-input])))
                            active-search? (and search (not (= search "")))
                            included-in-search? (s/includes? (fmt/lower-case (str short-name name)) search)
                            selected? (contains? (:selected-ids state) id)
                            hovered? (or (and active-search? included-in-search?) selected?)
                            open? (if (true? (:open state)) true (get-in state [:open id]))
                            new-props (assoc props :initialized? true
                                             :parent parent
                                             :children children
                                             :name name
                                             :short-name short-name
                                             :hovered? hovered?
                                             :selected? selected?
                                             :open? open?)
                            filter? (if (fn? (:filter props))
                                      ((:filter props) {:parent parent :children children})
                                      false)]
                        (when-not filter?
                          [:li
                           {:ref   auto-animate-ref
                            :key   (str "tree-indented-" id)
                            :class (when hovered? " is-hovered ")
                            :style {"--hover-border-color" (when (and (not (empty? (:selected-ids state)))
                                                                      (contains? (:selected-ids state) id))
                                                             "var(--success)")}}
                           [tree-indented-button new-props]
                           (when (and children open?)
                             [:f> tree-indented new-props])])))
                    (when children (sort-by #(if (fn? get-name-fn)
                                               (get-name-fn (second %))
                                               (get-in (second %) [:information :name]
                                                       (get-in (second %) [:information :short-name])))
                                            children))))]
    (if initialized?
      content
      [:div.tree-indented
       {:style {"--hover-background-color" "transparent"
                "--horizontal-line-position" "0.9em"}}
       content])))